import { Tooltip } from "@mui/material";
import { tv } from "tailwind-variants";

/**
 * Style
 */

const { bg, text } = tv({
  slots: {
    bg: "w-full h-7 flex items-center justify-center rounded-[4px] cursor-pointer",
    text: "font-semibold",
  },
  variants: {
    color: {
      red: {
        bg: "bg-red-500",
        text: "text-white",
      },
      blue: {
        bg: "bg-blue-500",
        text: "text-white",
      },
      yellow: {
        bg: "bg-yellow-400",
        text: "text-black",
      },
      green: {
        bg: "bg-primary-green",
        text: "text-white",
      },
      gray: {
        bg: "bg-gray-400/30",
        text: "text-black",
      },
    },
  },
})();

/**
 * LargeItemStatus
 */

interface Props {
  color: "red" | "blue" | "yellow" | "green" | "gray";
  title: string;
  description: string;
}

function LargeItemStatus({ color, title, description }: Props) {
  return (
    <>
      <Tooltip title={description}>
        <div className={bg({ color: color })}>
          <h1 className={text({ color: color })}>{title}</h1>
        </div>
      </Tooltip>
    </>
  );
}

export default LargeItemStatus;
